import { useState } from 'react';
import { RadiusIcon } from '@rsos/base-assets/icons';
import { Box, Text } from '@rsos/base-components';
import { HoveredCopyButton } from '../../HoveredButtons';
import { handleSetIsCopiedTimer } from '../../HoveredButtons/helpers';
import { CopyableBox, IconWrapper } from './DataCardLocation.styles';

interface UncertaintyInterface {
  uncertaintyRadius: number | null;
}

const Uncertainty = ({ uncertaintyRadius }: UncertaintyInterface) => {
  const [isCopied, setIsCopied] = useState(false);

  if (
    uncertaintyRadius === null ||
    uncertaintyRadius === undefined ||
    Number.isNaN(uncertaintyRadius)
  )
    return null;

  const uncertaintyValue =
    uncertaintyRadius < 0
      ? 'Unknown'
      : `${Number(uncertaintyRadius).toFixed(1)}m`;

  const onClick = () => {
    handleSetIsCopiedTimer(setIsCopied);
  };

  return (
    <CopyableBox isCopied={isCopied}>
      <IconWrapper mr={2}>
        <RadiusIcon />
      </IconWrapper>
      <Box horizontal>
        <Text size="normal" color="secondaryText">
          Uncertainty Radius:&nbsp;
        </Text>
        <Text size="normal" color="primaryText">
          {uncertaintyValue}
        </Text>
      </Box>
      <HoveredCopyButton
        handleClick={onClick}
        copyableText={`${uncertaintyValue}`}
      />
    </CopyableBox>
  );
};

export default Uncertainty;
